export default "__VITE_ASSET__C3sMwn3I__"